/* global vendorSettings */
import CustomModalDialog from 'snippets/custom-modal-dialog/custom-modal-dialog'
import ProductCard from 'snippets/product-card/product-card'
import { getProductTitle } from 'libs/shopify'

export default function ProductVendorModal() {
  return (
    <>
      {vendorSettings.products.length > 0 && (
        <CustomModalDialog
          id={vendorSettings.idModal}
          header={vendorSettings.headingModal}
          content={<ContentCardList dataSettings={vendorSettings} />}
          footer={<ButtonLink dataSettings={vendorSettings} />}
          classHeader="text-base text-grey-1000 text-center p-4 border-b border-default md:px-6 md:py-5"
          classClose="absolute !w-5 !h-5 !p-0 !top-4 md:!top-5"
          classIcon="w-full h-full text-grey-500"
          classMain="relative w-full max-h-[90vh] flex flex-col bg-white rounded-t md:max-h-[80vh] md:rounded md:max-w-[496px]"
          classModal="h-[100dvh] md-max:items-end"
          classContent="overflow-y-auto h-full p-4 md:p-6"
        />
      )}

      {lookSettings.products.length > 0 && (
        <CustomModalDialog
          id={lookSettings.idModal}
          header={lookSettings.headingModal}
          content={<ContentCardList dataSettings={lookSettings} />}
          footer={<ButtonLink dataSettings={lookSettings} />}
          classHeader="text-base text-grey-1000 text-center p-4 border-b border-default md:px-6 md:py-5"
          classClose="absolute !w-5 !h-5 !p-0 !top-4 md:!top-5"
          classIcon="w-full h-full text-grey-500"
          classMain="relative w-full max-h-[90vh] flex flex-col bg-white rounded-t md:max-h-[80vh] md:rounded md:max-w-[496px]"
          classModal="md-max:items-end"
          classContent="overflow-y-auto h-full p-4 md:p-6"
        />
      )}
    </>
  )
}

function ContentCardList({ dataSettings }) {
  return (
    <div className="relative w-full">
      {dataSettings.products.map((product) => (
        <ProductCard
          title={getProductTitle(product.title)}
          handle={product.handle}
          imageUrl={[product.featuredImage]}
          variants={product.variants}
          size={product.metafields.sizes}
          idModal={dataSettings.idModal}
          classContentWrapper='flex flex-1 items-center justify-between gap-4 px-4 md:px-3 lg:px-6'
        />
      ))}
    </div>
  )
}

function ButtonLink({ dataSettings }) {
  return dataSettings.ctaTextModal && (
    <div className="relative w-full p-4 border-t border-default">
      <a href={dataSettings.ctaLink} className="button-primary w-full" title={dataSettings.ctaTextModal}>
        {dataSettings.ctaTextModal}
      </a>
    </div>
  )
}
